export enum Operation {
    REMOVE = 0,
    ADD = 1
}
